export default __webpack_public_path__ + "static/media/male_icon.43afcb99.png";